<div class="content__container">
  <div class="goback__wrapper" (click)="tornaIndietro()" *ngIf="canBack">
    <div class="goback__item">
      <span class="material-symbols-outlined"> chevron_left </span>
      {{ "base.altre_esperienze" | translate }}
    </div>
  </div>
  <h2 class="d-flex align-items-baseline flex-header tipovisita__title">
    <b>
      {{ tipovisita.titolo }}
    </b>
  </h2>
  <div
    class="tipovisita__subtitle"
    *ngIf="tipovisita.sottotitolo && tipovisita.sottotitolo !== ''"
  >
    {{ tipovisita.sottotitolo }}
  </div>
  <app-tipologie-tipovisita
    [tipologie]="tipovisita.tipo"
    [cancellazione]="tipovisita.offsetOreCancella != 0 ? true : false"
  >
  </app-tipologie-tipovisita>
  <div class="price__container" *ngIf="tipovisita.nascondi_prezzo === '0'">
    <div class="from" *ngIf="chooseCostoMinimo(tipovisita) > 0">
      {{ "base.a_partire" | translate }}
    </div>
    <div class="price">
      <span *ngIf="chooseCostoMinimo(tipovisita) > 0">€</span>
      <span *ngIf="chooseCostoMinimo(tipovisita) > 0">
        {{ chooseCostoMinimo(tipovisita) | number : "1.2-2" }}
      </span>
      <span *ngIf="chooseCostoMinimo(tipovisita) == 0">
        {{ "base.gratis" | translate }}
      </span>
    </div>
  </div>
  <hr class="divisore" />

  <h2 class="head" (click)="emettiClick(tipovisita.id)">
    {{ "base.descrizione_visita" | translate }}
  </h2>
  <div class="mb-descrizione">
    <app-testo-espandibile
      [text]="tipovisita.descrizione"
    ></app-testo-espandibile>
  </div>
  <div
    *ngIf="tipovisita.vinidegustabili && tipovisita.vinidegustabili.length > 0"
  >
    <h2 class="head">
      {{ "base.vini_inclusi" | translate }}
    </h2>
    <div class="mt-05 mb-2">
      <app-vini-inclusi [vini]="tipovisita.vinidegustabili"></app-vini-inclusi>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <div class="button__container">
      <button
        class="button__booking"
        (click)="emettiClick(tipovisita.id)"
        *ngIf="
          tipovisita.totVisite !== '0' &&
          !prenotazione &&
          tipovisita.nascondi_prezzo === '0'
        "
      >
        {{ "base.scegli_posti" | translate }}
        <span class="material-symbols-outlined action-icon">
          edit_calendar
        </span>
      </button>
      <button
        class="button__booking"
        *ngIf="
          tipovisita.nascondi_prezzo === '0' &&
          ((checkRegalabile(tipovisita) && prenotazione) ||
            (checkRegalabile(tipovisita) && !procedi))
        "
        (click)="goToRegaloCantineWine(tipovisita)"
      >
        {{ "base.regala" | translate }}
        <span class="material-symbols-outlined action-icon">
          card_giftcard
        </span>
      </button>
      <button
        class="button__booking"
        *ngIf="tipovisita.totVisite === '0'"
        (click)="goToRichiediCantineWine(tipovisita)"
      >
        {{ "base.richiedi" | translate }}
        <span class="material-symbols-outlined action-icon"> email </span>
      </button>
    </div>
  </div>

  <div class="last__step mt-3 mt-md-3" *ngIf="cart && procedi && prenotazione">
    <app-last-step-tipovisita
      [codiceForm]="codiceForm"
      [codiceFormMaster]="codiceFormMaster"
      [tipovisita]="tipovisita"
      [linguaCorrente]="linguaCorrente"
    ></app-last-step-tipovisita>
  </div>

  <div class="last__step mt-3 mt-md-3" *ngIf="cart && procedi && !prenotazione">
    <app-last-step-buonocantina
      [codiceForm]="codiceForm"
      [codiceFormMaster]="codiceFormMaster"
      [tipovisita]="tipovisita"
      [linguaCorrente]="linguaCorrente"
    ></app-last-step-buonocantina>
  </div>
</div>
